import { GetShippingSitesResponse } from "@/app/api/shipping-sites/route";
import { getShippingSitesRequestSchema } from "@/lib/schemas/shipping-sites";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const SHIPPING_SITES_ENDPOINT = "/api/shipping-sites";

export const invalidateShippingSitesQuery = createInvalidateQuery(
  SHIPPING_SITES_ENDPOINT,
);

export const useShippingSitesQuery = createQueryHook<GetShippingSitesResponse>(
  SHIPPING_SITES_ENDPOINT,
  getShippingSitesRequestSchema,
);
